/**
 * Created by Colin.Watson on 4/2/2015.
 */

(function () {
	'use strict';

	angular
        .module('blocks.exception')
        .factory('ExceptionHandler', exception);

	exception.$inject = ['LoggerService'];
	function exception(logger) {
		var service = {
			catcher: catcher
		};
		return service;

		function catcher(message) {
			return function (reason) {
				logger.error(message, reason);
			};
		}
	}
})();
